export default __webpack_public_path__ + "static/media/CanadaSuicidePrevention.a16cae40.png";